import type { InternalRequest } from '../client.js';

type Params = Record<string, string | number | boolean | undefined | null>;

function qsFrom(params?: Params): string {
  if (!params) return '';
  const entries = Object.entries(params).filter(([, v]) => v != null && v !== '');
  if (!entries.length) return '';
  const usp = new URLSearchParams();
  for (const [k, v] of entries) usp.set(k, String(v));
  return `?${usp}`;
}

/** /api/forms — renamed from /api/inspections (templates only). */
export function formsEndpoints(req: InternalRequest) {
  return {
    list: (params?: Params) => req.request<unknown[]>(`/forms${qsFrom(params)}`),
    get: (id: string) => req.request<unknown>(`/forms/${id}`),
    create: (data: Record<string, unknown>) =>
      req.request<unknown>('/forms', { method: 'POST', body: JSON.stringify(data) }),
    /** Server uses PUT for full replace. */
    update: (id: string, data: Record<string, unknown>) =>
      req.request<unknown>(`/forms/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: string) =>
      req.request<void>(`/forms/${id}`, { method: 'DELETE' }),
  };
}
